import { MessengerV2 } from 'lib-shared-legacy-types';

import { WebformEndpoint } from 'apis/webformEndpoints';

import { EndpointMessengers } from '../customForms.types';

const getEndpointFriendlyId = (endpoint: WebformEndpoint): string | undefined =>
  endpoint.endpoint_uri.split('/').pop();

const hasEndpointId =
  (endpointId: string) =>
  (messenger: MessengerV2): boolean => {
    const widgetMode = messenger.settings?.general?.widgetMode;
    return (
      widgetMode?.type === 'form-without-conversation-widget-mode' &&
      widgetMode.friendlyEndpointId === endpointId
    );
  };

export function findEndpointsMessengers(
  endpoints: readonly WebformEndpoint[],
  messengers: readonly MessengerV2[],
): EndpointMessengers[] {
  return endpoints
    .map((endpoint) => {
      const friendlyId = getEndpointFriendlyId(endpoint);
      const messengersInfo = friendlyId
        ? messengers.filter(hasEndpointId(friendlyId)).map(({ id, name }) => ({
            messengerId: id,
            messengerName: name,
          }))
        : [];

      return {
        endpoint,
        messengersInfo,
      };
    })
    .filter(({ messengersInfo }) => messengersInfo.length > 0);
}
